<ng-select
  [clearable]="true"
  [clearOnBackspace]="false"
  class="w-custom"
  *ngIf="
    from === 'materialIngridiant' ||
    from === 'materialProcess' ||
    from === 'conversion' ||
    from === 'myProject'
  "
  #select
  [ngClass]="
    from === 'materialIngridiant' || from === 'materialProcess' ? 'personalInputFiled' : ''
  "
  [items]="processList"
  [searchable]="false"
  [bindLabel]="bindLabel"
  bindValue="id"
  [(ngModel)]="processId"
  [searchFn]="commonInputSearch"
  [placeholder]="placeHolder"
  groupBy="childItems"
  (change)="updateValue(processId)"
  [virtualScroll]="true"
>
  <ng-template ng-header-tmp>
    <div class="has-feedback">
      <input
        type="text"
        class="form-control accordion-search search-input"
        id="inputValidation"
        (input)="select.filter($any($event.target).value)"
        placeholder="Search..."
      />
      <span class="form-control-feedback">
        <i class="fa fa-search icon"></i>
      </span>
    </div>
  </ng-template>
  <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
    <div
      *ngIf="bindLabel === 'description'"
      title="{{ item?.description }}"
      [ngOptionHighlight]="search"
    >
      {{ item?.description }}
    </div>
    <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
      {{ item.name }}
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div
      *ngIf="bindLabel === 'description'"
      title="{{ item?.description }}"
      [ngOptionHighlight]="search"
    >
      {{ item?.description }}
    </div>
    <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
      {{ item.name }}
    </div>
  </ng-template>
</ng-select>

<ng-select
  [clearable]="true"
  [clearOnBackspace]="false"
  *ngIf="
    from !== 'materialIngridiant' &&
    from !== 'materialProcess' &&
    from !== 'conversion' &&
    from !== 'myProject'
  "
  #select
  [items]="processList"
  [ngClass]="from == 'recycledItems' ? 'recycledDrp' : ''"
  [searchable]="false"
  [bindLabel]="bindLabel"
  bindValue="id"
  [(ngModel)]="processId"
  [searchFn]="commonInputSearchForName"
  [placeholder]="placeHolder"
  (change)="updateValue(processId)"
  [virtualScroll]="true"
>
  <ng-template ng-header-tmp>
    <div class="has-feedback">
      <input
        type="text"
        class="form-control accordion-search search-input"
        id="inputValidation"
        (input)="select.filter($any($event.target).value)"
        placeholder="Search..."
      />
      <span class="form-control-feedback">
        <i class="fa fa-search icon"></i>
      </span>
    </div>
  </ng-template>
  <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
    <div
      *ngIf="bindLabel === 'description'"
      title="{{ item?.description }}"
      [ngOptionHighlight]="search"
    >
      {{ item?.description }}
    </div>
    <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
      {{ item.name }}
    </div>
  </ng-template>
  <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
    <div
      *ngIf="bindLabel === 'description'"
      title="{{ item?.description }}"
      [ngOptionHighlight]="search"
    >
      {{ item?.description }}
    </div>
    <div *ngIf="bindLabel === 'name'" title="{{ item?.name }}" [ngOptionHighlight]="search">
      {{ item.name }}
    </div>
  </ng-template>
</ng-select>
<div class="addtooltips align-self-center" *ngIf="from == 'materialIngridiant'">
  <ng-template #tipContent>
    <div class="row">
      <span class="selectedMaterialDiv d-flex align-items-start justify-content-start text-left">{{
        materialname
      }}</span>
      <div
        class="col-md-12 d-flex align-items-start justify-content-start pt-2"
        *ngFor="let item of materialInfoData | keyvalue; let i = index"
      >
        <ng-container *ngIf="materialInfoDataKey[i] !== 'name'">
          <span class="col-4 d-flex align-items-start justify-content-start alignData"
            >{{ materialInfoDataKey[i] }}:
          </span>
          <span class="col-8 d-flex align-items-start justify-content-start alignData"
            >{{ materialInfoDataValues[i] }}
          </span>
        </ng-container>
      </div>
    </div>
  </ng-template>
  <div
    placement="auto"
    [ngbTooltip]="tipContent"
    tooltipClass="custom-tooltip"
    container="body"
    data-bs-placement="auto"
  >
    <a> <i class="bi bi-info-circle iconQuestion"></i></a>
  </div>
</div>
